import React from "react";
import { useField } from "formik";
import { Dropdown } from "primereact/dropdown";
import { useTranslation } from "react-i18next";

const sharedPt = (lang) => ({
  dropdownicon: { className: "h-[10px] w-[10px] md:h-[12px] md:w-[12px]" },
  header: { className: "p-[10px]" },
  item: { className: "capitalize !outline-none" },
  filterinput: { className: "h-[30px] !text-[10px] md:!text-[12px]" },
  filtericon: {
    className: `absolute ${lang === "en" ? "!right-[1rem] !left-auto" : "!left-[1rem] !right-auto"}`,
  },
  input: { className: "!text-[10px] md:!text-[12px] !p-[6px]" },
  itemgrouplabel: {
    className:
      "!text-primary !font-semibold capitalize text-[10px] md:text-[12px]",
  },
  itemlabel: { className: "!text-[10px] md:!text-[12px]" },
  clearicon: {
    className: `!text-dark absolute ${lang === "en" ? "!right-[2.3rem] !left-auto" : "!left-[2.3rem] !right-auto"}`,
  },
});

const isGrouped = (options = []) =>
  Array.isArray(options) && options.length > 0 && options[0].options;

const FormikDropdownField = ({
  label = "",
  name = "",
  className = "",
  options = [],
  optionLabel = "label",
  optionValue = "value",
  placeholder,
  parentClass = "",
  filter = false,
  showClear = false,
  filterPlaceholder = "Search",
  hideErrorText = false,
  ...props
}) => {
  const [field, meta] = useField(name);
  const { t, i18n } = useTranslation();

  const isInvalid = meta.error && meta.touched;

  return (
    <div className={`flex flex-col gap-1 w-full mb-1 ${parentClass}`}>
      {label && (
        <label htmlFor={name} className="input-label">
          {label}
        </label>
      )}

      <Dropdown
        options={options}
        optionLabel={optionLabel}
        optionValue={optionValue}
        {...(isGrouped(options) && {
          optionGroupLabel: "label",
          optionGroupChildren: "options",
        })}
        placeholder={placeholder}
        filter={filter}
        filterPlaceholder={t(filterPlaceholder)}
        className={`!w-full ${className} input-field !p-0  ${isInvalid && hideErrorText ? "!border-red-500" : ""}`}
        pt={sharedPt(i18n.language)}
        showClear={showClear}
        {...field}
        {...props}
      />

      {isInvalid && !hideErrorText && (
        <p className="text-red-500 text-sm">{meta.error}</p>
      )}
    </div>
  );
};

const StandaloneDropdownField = ({
  label = "",
  options = [],
  optionLabel = "label",
  optionValue = "value",
  parentClass = "",
  placeholder = "",
  className = "",
  value = null,
  filter = false,
  ptOptions = null,
  filterPlaceholder = "Search",
  showClear = false,
  NavigationIcon,
  onIconClick = () => {},
  handleChange = () => {},
  ...props
}) => {
  const { t, i18n } = useTranslation();

  return (
    <div className={`flex flex-col gap-1 w-full mb-1 ${className}`}>
      {label && (
        <div className="flex items-center justify-between">
          <label className="input-label">{label}</label>
          {NavigationIcon && (
            <NavigationIcon
              size={17}
              className="text-primary cursor-pointer"
              onClick={onIconClick}
            />
          )}
        </div>
      )}

      <Dropdown
        options={options}
        optionLabel={optionLabel}
        optionValue={optionValue}
        {...(isGrouped(options) && {
          optionGroupLabel: "label",
          optionGroupChildren: "options",
        })}
        placeholder={placeholder}
        value={value}
        filter={filter}
        filterPlaceholder={t(filterPlaceholder)}
        onChange={handleChange}
        className={`!w-full input-field ${className} !p-0`}
        pt={ptOptions ? ptOptions : sharedPt(i18n.language)}
        showClear={showClear}
        {...props}
      />
    </div>
  );
};

const DropdownComponent = (props) => {
  const { useFormik = true } = props;
  return useFormik ? (
    <FormikDropdownField {...props} />
  ) : (
    <StandaloneDropdownField {...props} />
  );
};

export default DropdownComponent;
